// extracted by mini-css-extract-plugin
export default {"filtersContainer":"FiltersContainer_filtersContainer__M5q5+","filterTitle":"FiltersContainer_filterTitle__j7sWk","closeContainer":"FiltersContainer_closeContainer__E-+mi"};